import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import APP_LIST, { HOME_APP } from "./config/constants/routes";
import { HeaderPortalProvider } from "./config/contexts/HeaderPortalContext";
import reduxStore, { reduxPersistor } from "./config/redux";
import ErrorPage from "./pages/ErrorPage";
import LandingPage from "./pages/Landing";
import Layout from "./pages/Layout";
import LoginPage from "./pages/Login";
import RegisterPage from "./pages/Register";
import { StyledWrapper } from "./pages/Selector/styles";
import { CssBaseline } from "@mui/material";
import { ThemeContextProvider } from "./config/contexts/ThemeContext";
import ToastProvider from "./config/contexts/ToastProvider";

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/app",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [HOME_APP, ...APP_LIST],
  },
]);

const App = () => {
  return (
    <ReduxProvider store={reduxStore}>
      <PersistGate persistor={reduxPersistor}>
        <ThemeContextProvider>
          <CssBaseline />
          <HeaderPortalProvider>
            <StyledWrapper>
              <RouterProvider router={router} />
            </StyledWrapper>
            <ToastProvider />
          </HeaderPortalProvider>
        </ThemeContextProvider>
      </PersistGate>
    </ReduxProvider>
  );
};

export default App;
